"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPromise = void 0;
function isPromise(obj) {
  return typeof obj.then === 'function';
}
exports.isPromise = isPromise;